import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Injector,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IContentLanguageLabelModel } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { FiFormHelperService } from '@fi-shared/fi-form-shared/fi-form-helper.service';

@Component({
    selector: 'fi-form-question-names-editor',
    templateUrl: 'form-question-names-editor.component.html',
    styleUrls: ['./form-question-names-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-form-question-names-editor' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FiFormQuestionNamesEditorComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: FiFormQuestionNamesEditorComponent,
        },
    ],
    standalone: false,
})
export class FiFormQuestionNamesEditorComponent extends ControlValueAccessorValidatorBase<
    IContentLanguageLabelModel[]
> {
    @Input({ required: true }) selectedLanguageId: number;
    @Input({ required: true }) label: string;
    @Input({ required: true }) isFormTranslated: boolean;
    @Input({ required: true }) nameInputName: string;
    @Input() isQuestionNameFocused: boolean;

    @Input() hint: boolean;
    @Input() errorMessageLabelId: string = 'form.question_name_error';
    @Input() isQuestionMandatory: boolean;
    @Input() isQuestionIsDisabled: boolean;
    @Output() onDisableElementDrag = new EventEmitter<boolean>();

    constructor(
        injector: Injector,
        private fiFormHelperService: FiFormHelperService,
    ) {
        super(injector);
    }

    isQuestionNameContentLangIdSelected(contentLangId: number): boolean {
        return contentLangId === this.selectedLanguageId;
    }

    isQuestionNameRequired(questionName: IContentLanguageLabelModel): boolean {
        return this.fiFormHelperService.isQuestionNameRequired(questionName, this.isFormTranslated);
    }

    disableElementDrag(isDragDisabled: boolean) {
        this.onDisableElementDrag.emit(isDragDisabled);
    }
}
